// PlanningSection.js
import React, {useRef} from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Heading,
  Alert,
  AlertIcon,
  Icon,
  HStack,
  Text,
} from '@chakra-ui/react';
import usePlanning from '../hooks/usePlanning';
import { FaFileAlt } from 'react-icons/fa';
import Planning from '../components/home/sections/Planning';
import useSearchState from '../hooks/useSearch';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useNavigateViaHash } from '../hooks/useNavigateViaHash';

function PlanningSection() {
  const planningRef = useRef(null);
  useNavigateViaHash(planningRef, "planning");
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const { searchState } = useSearchState();
  const { validatedAddress } = searchState;
  // Call the custom hook to fetch planning data
  const result = usePlanning(validatedAddress);
  const { planningData, isLoading, error } = result;
  const applications = Array.isArray(planningData?.applications) ? planningData.applications : [];
  return (
    <Card ref={planningRef} variant='outline' mb={8} bg='brand.section'>
      <CardHeader>
        <Heading size='md'>
          <HStack>
            <Icon as={FaFileAlt} color='purple.500' />
            <Text>Planning Applications</Text>
          </HStack>
        </Heading>
      </CardHeader>
      <CardBody>
        {validatedAddress ? (
          <Planning
            applications={applications}
            isLoading={isLoading}
            error={error}
            validatedAddress={validatedAddress}
            location={{
              postcode: validatedAddress?.postcode,
              lat: validatedAddress?.lat,
              lng: validatedAddress?.lng,
            }}
            currentUser={currentUser}
            navigate={navigate}
          />
        ) : (
          <Alert status='info'>
            <AlertIcon />
            Search for an address to see local planning applications.
          </Alert>
        )}
      </CardBody>
    </Card>
  );
}

export default PlanningSection;
